import { API, Auth } from 'aws-amplify'
import React, { useState } from 'react'
import "bootstrap/dist/css/bootstrap.css";
import { Table } from '@aws-amplify/ui-react';
import EntityRow from './EntityRow';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import { Search } from 'react-bootstrap-icons';
import Select from 'react-select';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';

const EntityTable = (props) => {
  const [selectedOption, setSelectedOption] = useState([]);
  const [input, setInput] = useState("")
  const [entities, setEntities] = useState({ 'items': [] })
  const [text, setText] = useState("")
  const [isBusy, setIsBusy] = useState(false);
  const [pageno, setPageno] = useState("");
  const [notFoundText, setNotFound] = useState('');
  const projectId = props.project_id;
  const projectType = props.project_type;
  const routestypes = {
    'ediscovery': {
      main_path: '/ediscovery',
      file_path: '/filesediscovery/',
      main_path_breadcrumb: 'eDiscovery' 
    },
    'contractreview': {
      main_path: '/contractreview',
      file_path: '/filescontractreview/',
      main_path_breadcrumb: 'Contract Review' 
    },
    'caselawsearch': {
      main_path: '/caselawsearch',
      file_path: '/filescaselawsearch/',
      main_path_breadcrumb: 'Case Law Search' 
    }
  }
  const [errorMessage, setErrorMessage] = useState('');

  const search = async (e) => {
    setNotFound('');
    setIsBusy(true);
    setEntities(null)
    let apiPath = '';
    let categories = selectedOption.map((thisEntity) => { return thisEntity.label }).join(',')
    apiPath = `/entitysearch?projectid=${projectId}&keyword=${e.input}&categories=${categories}`

    const myAPI = "DocumentSearchUser"
    const user = await Auth.currentAuthenticatedUser()
    const requestInfo = { headers: { Authorization: user.signInUserSession.idToken.jwtToken } }
    API.get(myAPI, apiPath, requestInfo)
      .then(response => {
        setErrorMessage('');
        setIsBusy(false);
        console.log(response)
        setEntities(response.items)
        props.onSearch(response.report_id)
if(response.items.items.length == 0)
{
  setNotFound('No results found!');
}

      })
      .catch(error => {
        setIsBusy(false);
        console.log(error);
        if (error.response.status == 406) {
          setErrorMessage(error.response.data);
      }
      })
  };

  const handleDetail = async (entity) => {
    setIsBusy(true);
    setPageno('')
    const user = await Auth.currentAuthenticatedUser()
    const requestInfo = { headers: { Authorization: user.signInUserSession.idToken.jwtToken } }
    API.get('DocumentSearchUser', '/getfilecontent' + `?projectid=${projectId}&filename=${entity.file_name}&page=${entity.page}&startindex=${entity.BeginOffset}&endindex=${entity.EndOffset}`, requestInfo)
      .then(response => {
        // console.log(response)
        setErrorMessage('');
        setIsBusy(false);
        console.log(response)
        setText(response.text);
        setPageno(`Page ${response.page_no} of ${response.no_pages}`)
      })
      .catch(error => {
        setIsBusy(false);
        console.log(error);
        if (error.response.status == 406) {
          setErrorMessage(error.response.data);
      }
      })
  };
  const options = [
    { value: 'comercial_item', label: 'COMMERCIAL_ITEM' },
    { value: 'date', label: 'DATE' },
    { value: 'event', label: 'EVENT' },
    { value: 'location', label: 'LOCATION' },
    { value: 'organization', label: 'ORGANIZATION' },
    { value: 'person', label: 'PERSON' },
    { value: 'quantity', label: 'QUANTITY' },
    { value: 'title', label: 'TITLE' },
    // { value: 'other', label: 'OTHER' }
  ]

  return (
    <>
      <Row>
        <Col>
          <br />
          
          <Breadcrumb>
            {<Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Home</Breadcrumb.Item>}
            {<Breadcrumb.Item linkAs={Link} linkProps={{ to: routestypes[projectType]['main_path'] }}>{routestypes[projectType]['main_path_breadcrumb']}</Breadcrumb.Item>}
            {<Breadcrumb.Item linkAs={Link} linkProps={{ to: routestypes[projectType]['file_path'] + "?projectid=" + projectId }}>{projectId}</Breadcrumb.Item>}
            <Breadcrumb.Item active>Entity</Breadcrumb.Item>
          </Breadcrumb>
          
        </Col>
      </Row>
      <Row>
        <Col>
          <h1>Entity Search</h1>
        </Col>
      </Row>
      <Row>
        <Col >
          Select Entity Category from drop down menu (select at least 1 Entity Category)
        </Col>
      </Row>
      <Row>
        <Col sm="5">
          <Select options={options} isMulti onChange={setSelectedOption} />
        </Col>
      </Row>
      <Row>
        <Col >
          Type in selected criteria for selected Entity Categories (leave empty to retrieve all Entities for selected Entity Categories)
        </Col>
      </Row>
      <Row>
        <Col sm="5">
          <InputGroup className="mb-3">
            <FormControl
              placeholder="enter search phrase"
              aria-label="enter search phrase"
              aria-describedby="basic-addon2"
              value={input} onChange={(e) => setInput(e.target.value)}
            />
            <Button variant="outline-secondary" id="button-addon2" onClick={() => search({ input })}>
              <Search />
            </Button>
          </InputGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          {isBusy &&
            <Spinner animation="border" role="status" variant="primary">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          }
        </Col>
      </Row>
      <Row style={{ 'marginTop': '1em' }} >
                <Col>
                    {errorMessage && (
                        <Alert key="danger" variant="danger">
                            {errorMessage}
                        </Alert>
                    )}
                </Col>
            </Row>
      <Row>
      {/* <Col>
      <h5 style={{ color: 'red' }}>{notFoundText}</h5>
      </Col> */}
        <Col>
          <div key={entities?.user_id} className="float-child">
            <div style={{ "height": "50vh", "overflow-x": "hidden", "overflow-y": "auto" }}>
            <h5 style={{ color: 'red' }}>{notFoundText}</h5>
              <Table>
                <tbody>
                  {
                    entities?.items.map((thisEntity, index) => {
                      return (
                        <EntityRow key={index} entity={thisEntity} projectId={projectId} OnDetail={handleDetail} />
                      )
                    })
                  }
                </tbody>
              </Table>
            </div>
          </div>
          <div className="float-child">
            <div id='doctextarea' style={{ "width": "100%", "height": "50vh", "padding": "20px", "overflow-y": "auto" }} readOnly dangerouslySetInnerHTML={{ __html: text }}></div>
            <div style={{ textAlign: 'right' }}>
              {pageno}
            </div>
          </div>
        </Col>
      </Row>
    </>
  )
}
export default EntityTable;